import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';

export const AGENT_STATE_KEY = 'agent_state';

export interface Status {
  id: number;
  isFavourite: boolean;
  value: string;
}

export interface AgentState {
  allStatus: Status[];
  currentStatus: string;
  isWorkingOB: boolean;
}

export const agentStateStatus: AgentState = {
  allStatus: [
    {
      id: 1,
      isFavourite: true,
      value: 'Break',
    },
    {
      id: 2,
      isFavourite: true,
      value: 'Meeting',
    },
    {
      id: 3,
      isFavourite: true,
      value: 'Lunch',
    },
    {
      id: 4,
      isFavourite: true,
      value: 'Coaching',
    },
    {
      id: 5,
      isFavourite: true,
      value: 'Personal',
    },

    {
      id: 6,
      isFavourite: false,
      value: 'Offsite',
    },
    {
      id: 7,
      isFavourite: false,
      value: 'HR',
    },
    {
      id: 8,
      isFavourite: false,
      value: 'DataEntry',
    },
    {
      id: 9,
      isFavourite: false,
      value: 'PerformanceReview',
    },
    {
      id: 10,
      isFavourite: false,
      value: 'Conference',
    },
    {
      id: 11,
      isFavourite: false,
      value: 'Research',
    },
    {
      id: 12,
      isFavourite: false,
      value: 'Client',
    },
    {
      id: 13,
      isFavourite: false,
      value: 'available',
    },
    {
      id: 14,
      isFavourite: true,
      value: 'WorkingOB',
    },
  ],
  currentStatus: 'unavailable',
  isWorkingOB: false,
  //resetTimer: false,
};

export const agentStateSlice = createSlice({
  name: AGENT_STATE_KEY,
  initialState: agentStateStatus,
  reducers: {
    /**
     * Function to set current status of agent
     * @param state - AgentState
     * @param action  - PayloadAction<string>
     * @returns It returns current status of agent
     * @example -setCurrentStatus('Available')
     */
    setCurrentStatus(state, action: PayloadAction<string>) {
      return {
        ...state,
        currentStatus: action.payload,
        isWorkingOB: action.payload === 'Working-OB' ? true : false,
      };
    },
    /**
     * Function to update favourite status of agent
     * @param state - AgentState
     * @param action  - PayloadAction<string>
     * @returns It returns favourite status
     * ```
     * @example -const status {
     * id?: 12;
     * isFavourite?: true;
     * value?: 'Client';
     * }
     *```
     */
    updateFavourite(state, action: PayloadAction<Status>) {
      return {
        ...state,
        allStatus: state.allStatus.map((status) =>
          status.id === action.payload.id
            ? { ...status, isFavourite: !action.payload.isFavourite }
            : status
        ),
      };
    },
  },
});

export const agentStateReducer = agentStateSlice.reducer;
export const agentStateActions = agentStateSlice.actions;

/**
 * Function to get status of agent
 * @param rootState - AgentState
 * @returns It returns agent status
 * @example - const agentState = getAgentState(rootState)
 */
const getAgentState = (rootState: { agent_state: AgentState }) => {
  return rootState[AGENT_STATE_KEY];
};

export const selectStatus = createSelector(getAgentState, (state) => {
  return state;
});

export const selectcurrentStatus = createSelector(
  getAgentState,
  (state) => state.currentStatus
);

export const selectIsWorkingOB = createSelector(
  getAgentState,
  (state) => state.isWorkingOB
);
